module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (6).eb6902a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (6).jpg
// module id = 345
// module chunks = 0